import React from 'react';
require('../../css/components/LoginDialog.scss');

'use strict';

export default class ShortcodeDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: false, enteredShortcode: null };
    }

    changeEnteredShortcode(event) {
        this.setState({ enteredShortcode: event.target.value });
    }

    handleKeyUp(event) {
        if (event.keyCode === 13) {
            this.verifyShortcode();
        }
    }

    verifyShortcode() {
        fetch(this.props.apiUrl + '/' + this.state.enteredShortcode)
            .then((response) => {
                if (response.ok) {
                    this.props.setShortcode(this.state.enteredShortcode);
                    this.setState({
                        error: false
                    });
                }
                else {
                    this.setState({
                        error: true
                    });
                }
            });
    }

    render() {
        var header = [];

        if (this.props.showLogo)
            header.push(
                React.createElement(
                    'img', { key: 'img', src: '/img/healthclips-online.svg' })
            );

        if (this.props.enableDismiss)
            header.push([
                React.createElement(
                    'button', { key: 'button', type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'close' },
                React.createElement(
                    'span', { 'aria-hidden': 'true' }, String.fromCharCode(215)))
            ]);

        return React.createElement(
            'div', { className: 'loginDialog' },
            [
                React.createElement(
                    'div', { key: 'header', className: 'modal-header' },
                    header
                ),
                React.createElement(
                    'div', { key: 'body', className: 'modal-body' },
                    [
                        React.createElement(
                            'p', { key: 'p', className: 'loginDialog__sub-heading', dangerouslySetInnerHTML: { __html: this.props.copy.enterShortcodeHeading } })
                    ],
                    React.createElement(
                        'input', { key: 'input', onKeyUp: this.handleKeyUp.bind(this), placeholder: this.props.copy.enterShortcode, onChange: this.changeEnteredShortcode.bind(this) }),
                ),
                React.createElement(
                    'div', { key: 'footer', className: 'modal-footer' },
                    [
                        React.createElement(
                            'div',
                            {
                                key: 0, className: ''
                            }, [
                            React.createElement(
                                'div',
                                {
                                    key: 0, className: 'modal-error-message'
                                },
                                this.state.error || this.props.displayInvalidShortcodeMessage ? this.props.copy.invalidShortcode : null)
                            ,
                            React.createElement(
                                'button',
                                {
                                    key: 1, type: 'button', className: 'btn btn-success',
                                    onClick: this.verifyShortcode.bind(this)
                                },
                                this.props.copy.loginNow)
                            ]
                        )
                    ]
                )
            ]
        );
    }
}
